import { InjectionToken } from '@angular/core';
import { ConstitutionTicketsRepository } from '../domain/repository/constitution-tickets.repository';

export const CONSTITUTION_TICKETS_REPOSITORY = new InjectionToken<ConstitutionTicketsRepository>('CONSTITUTION_TICKETS_REPOSITORY');
